import React, { useMemo } from 'react'
import PropTypes from 'prop-types'; 
import { APIsTable } from './APIsTable' 
import { Table as T, TableContent } from 'reatable' 

const getColumn = (data) => { 
    const basis = data.length ? data[0] : {}
    return Object.keys(basis).map((key) => {
        return {
            dataIndex: key,
            label: key.replace(/^(.)/, (match, get) => get.toUpperCase()),
        }
    })
}

const Table = ({ data }) => {
    const columns = useMemo(() => getColumn(data), [data])
    return (
        <T 
            columns={columns}
            data={data}
        >	
            <div className='n-flat of-y-auto br-1r'>
                <TableContent className='table-api n-table-bordered n-text-color' />
            </div>
        </T>
    );
}

Table.propTypes = {
	data: PropTypes.arrayOf(PropTypes.object),
};

Table.ForAPI = APIsTable

export default Table;
